/** POST /api/klaviyo/events, with optional list assignment metadata. */
export interface SendKlaviyoEventRequest {
  email: string;
  metric_type: string;
  list_name?: string | null;
  first_name?: string | null;
  last_name?: string | null;
}

export const sendKlaviyoEvent = async (payload: SendKlaviyoEventRequest) => {
  const baseApiUrl = import.meta.env.VITE_BASE_API_URL;

  const response = await fetch(`${baseApiUrl}/klaviyo/events`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
    body: JSON.stringify(payload),
  });

  if (!response.ok) {
    const errorBody = await response.json().catch(() => null);
    console.error("Failed to send Klaviyo event:", response.status, errorBody);
    throw new Error(
      `Klaviyo event failed (${response.status})`,
    );
  }

  return response.json();
};
